import { render, staticRenderFns } from "./ProjectDataSheet.vue?vue&type=template&id=c82317c8&scoped=true"
import script from "./ProjectDataSheet.vue?vue&type=script&lang=ts"
export * from "./ProjectDataSheet.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDataSheet.vue?vue&type=style&index=0&id=c82317c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82317c8",
  null
  
)

export default component.exports